import { combineReducers } from 'redux'
import auth from 'actions/auth'
import config from 'actions/config'
import fund from 'actions/fund'
import dialog from './dialog'
import dashboard from 'actions/dashboard'
import { reducer as formReducer } from 'redux-form'

const rootReducer = combineReducers({
  auth,
  config,
  fund,
  dashboard,
  dialog,
  form: formReducer,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js